import React from "react";
import { STATES } from "@/components/StateRequestSection";

const LANGS = [["en", "English"], ["hi", "हिन्दी (Hindi)"], ["or", "ଓଡ଼ିଆ (Odia)"], ["bn", "বাংলা (Bengali)"], ["te", "తెలుగు (Telugu)"],
  ["ta", "தமிழ் (Tamil)"], ["kn", "ಕನ್ನಡ (Kannada)"], ["ml", "മലയാളം (Malayalam)"], ["mr", "मराठी (Marathi)"],
  ["gu", "ગુજરાતી (Gujarati)"], ["pa", "ਪੰਜਾਬੀ (Punjabi)"], ["as", "অসমীয়া (Assamese)"], ["ur", "اردو (Urdu)"]];

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="text-sm font-semibold text-thali-ink/80">{label}</span>
    <div className="mt-1">{children}</div>
    {hint && <span className="text-xs text-thali-ink/50">{hint}</span>}
  </label>
);

export default function StepBasics({ cfg, set, b }) {
  return (
    <div className="space-y-4" data-testid="step-basics">
      <Field label={b("calc_name")}>
        <input className="input-thali" maxLength={80} value={cfg.name} placeholder="e.g. Bihar PM POSHAN 2026"
          onChange={(e) => set((c) => ({ ...c, name: e.target.value }))} data-testid="b-name" />
      </Field>
      <Field label={b("state")}>
        <select className="input-thali" value={cfg.state} onChange={(e) => set((c) => ({ ...c, state: e.target.value }))} data-testid="b-state">
          <option value="">—</option>
          {STATES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </Field>
      <Field label={b("language")}>
        <select className="input-thali" value={cfg.language || "en"} onChange={(e) => set((c) => ({ ...c, language: e.target.value }))} data-testid="b-language">
          {LANGS.map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </Field>
      <Field label={b("notes")}>
        <textarea className="input-thali min-h-[80px]" maxLength={500} value={cfg.notes || ""}
          onChange={(e) => set((c) => ({ ...c, notes: e.target.value }))} data-testid="b-notes" />
      </Field>
    </div>
  );
}
